import { render, staticRenderFns } from "./NewProductSystemWizard.vue?vue&type=template&id=07886d0e&scoped=true"
import script from "./NewProductSystemWizard.vue?vue&type=script&lang=ts"
export * from "./NewProductSystemWizard.vue?vue&type=script&lang=ts"
import style0 from "./NewProductSystemWizard.vue?vue&type=style&index=0&id=07886d0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07886d0e",
  null
  
)

export default component.exports